import { createFileRoute } from "@tanstack/react-router"
import { OverviewPage } from "@/features/crawl-dashboard/OverviewPage"

export const Route = createFileRoute("/crawl/")({
	component: OverviewPage,
})
